module.exports = __webpack_public_path__ + "static/media/avatar.6715d5a6.svg";